import { Steps, Typography } from 'antd';

const setupStages = [
  { title: 'Organization Profile', description: 'Company information' },
  { title: 'Organization Structure', description: 'Division, department, position' },
  { title: 'Working Calendar', description: 'Working days and hours' },
  { title: 'Review & Finish', description: 'Review and start using WorkPlansIQ' },
];

export default function SetupProgressHeader({ current = 0, title, description }) {
  return (
    <section className="setup-progress-header" aria-label="Initial setup progress">
      <div className="setup-progress-header__intro">
        <Typography.Text className="onboarding-eyebrow">INITIAL SETUP</Typography.Text>
        <Typography.Title level={2}>{title}</Typography.Title>
        <Typography.Paragraph>{description}</Typography.Paragraph>
      </div>
      <Steps current={current} responsive items={setupStages} />
    </section>
  );
}
